import { Flex, Space, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import CurrencyAmount from "src/components/CurrencyAmount";

type EarlyPaymentBreakdownProps = {
  /** Portion of the withdrawal covered by the existing balance. */
  fromBalance: number;
  /** Portion advanced as an early payment. */
  loanPortion: number;
  /** Fee charged on the advanced portion. */
  epFee: number;
  /** Effective fee percent shown next to the fee row. */
  feePercent: number;
  currency: "GBP" | "USDT" | "IRT";
};

/**
 * Breakdown of an early-payment withdrawal (from balance / advance / fee).
 * Shared between the IRT and USDT withdrawal forms.
 */
export function EarlyPaymentBreakdown({
  fromBalance,
  loanPortion,
  epFee,
  feePercent,
  currency,
}: EarlyPaymentBreakdownProps) {
  return (
    <div className="rounded-xl bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-800 p-4">
      <Flex align="center" gap={6} className="mb-3">
        <InfoCircleOutlined className="text-blue-500" />
        <Typography.Text strong className="text-blue-700 dark:text-blue-400">
          جزئیات پرداخت 
        </Typography.Text>
      </Flex>
      <Space direction="vertical" style={{ width: "100%" }} size={4}>
        <Flex justify="space-between" className="text-sm">
          <Typography.Text type="secondary">از دارایی</Typography.Text>
          <CurrencyAmount amount={fromBalance} currency={currency} />
        </Flex>
        <Flex justify="space-between" className="text-sm">
          <Typography.Text type="secondary">پرداخت زودهنگام</Typography.Text>
          <CurrencyAmount amount={loanPortion} currency={currency} />
        </Flex>
        <Flex justify="space-between" className="text-sm">
          <Typography.Text type="secondary">
            کارمزد پرداخت زودهنگام ({feePercent}٪)
          </Typography.Text>
          <CurrencyAmount amount={epFee} currency={currency} />
        </Flex>
      </Space>
      <Typography.Text type="secondary" className="text-xs mt-3 block">
        <InfoCircleOutlined className="ml-1" />
        پرداخت زودهنگام پس از تأیید پردازش می‌شود.
      </Typography.Text>
    </div>
  );
}

export default EarlyPaymentBreakdown;
